import React from "react"
import PropTypes from "prop-types"
import withQueryParams from "src/hocs/withQueryParams"
import { compose, withProps } from "recompact"
import { Box } from "@infotech/uikit-grid"
import PlanResourceList from "./PlanResourceList"
import NewPlanResourceList from "./NewPlanResourceList"
import styles from "./styles.css"

const enhancer = compose(
  withQueryParams(),
  withProps(
    props =>
      props.match.params && {
        planId: props.match.params.id || props.match.params.planId || props.id,
        basicUrl: props.basicUrl,
      },
  ),
)

const PlanResourcesModal = ({ planId, disableEdit, dataForTabs }) => {
  const isNew = Boolean(planId === `new`)
  return (
    <>
      {isNew ? (
        <NewPlanResourceList />
      ) : (
        <Box loose className={styles.PlanResourcesTab}>
          <PlanResourceList
            planId={planId}
            isDisabled={disableEdit}
            dataForTabs={dataForTabs}
          />
        </Box>
      )}
    </>
  )
}

PlanResourcesModal.propTypes = {
  planId: PropTypes.string.isRequired,
  disableEdit: PropTypes.bool.isRequired,
}

export default enhancer(PlanResourcesModal)
